import type { FilterModule } from "../index";
import { RankingsFilter } from "./RankingsFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultRankingsSlice, type RankingsSlice } from "./slice";

export type { RankingsSlice } from "./slice";
export { defaultRankingsSlice } from "./slice";

export const rankingsModule: FilterModule<RankingsSlice> = {
  key: "rankings",
  defaultSlice: defaultRankingsSlice,
  Component: RankingsFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
